import * as React from "react";
import * as Rest from "../Generated/RestClient";
import {clientAppSettings} from "../Models/ClientAppSettings"
import {resourceStrings} from "../../../Intercom.ReactUI/Views/Strings";
import reflectName from "../../../Intercom.ReactUI/Utils/NameReflector";
import {log} from "../../../Intercom.ReactUI/Utils/clacky";
import { BlockRowInputLabel } from './Shared/BlockRowInputLabel';

export interface BotMsaEditorProps extends React.Props<BotMsaEditor> {
    inCreateMode: boolean,
    buttonClassName?: string,
    errors: { [key: string]: string },
    handleChange(field:string, ev: React.FormEvent<any>),
    isAppTypeFlighted: boolean;
    bot: Rest.BotService,
}

export interface BotMsaEditorState {
    uniqueId: string
}

export class BotMsaEditor extends React.Component<BotMsaEditorProps, BotMsaEditorState> {
    public appSecret: HTMLInputElement;
    constructor(props: BotMsaEditorProps) {
        super(props);
        this.state = {
            uniqueId: 'MsaEditor' + new Date().valueOf()
        }
    }

    private checkForAppID(requestingId: string) {
        const msaAppId = this.props.bot.MsaAppId;
        //see if thethe requestingId is still on this page
        if (document.getElementById(requestingId) && !msaAppId) {

            //this is a workaround for IE to trigger a refresh of localStorage
            localStorage.setItem('temp', '0');
            localStorage.removeItem('temp');

            //see if the other tab has set the createId
            var createId = localStorage.getItem('createId');
            if (createId) {

                localStorage.removeItem('createId');
                (window as any).refreshBotMsaApp(createId);

            } else {
                setTimeout(() => { this.checkForAppID(requestingId); }, 500);
            }
        }
    }


    private openMSAPage() {
        if (this.props.inCreateMode) {
            log('/bots/create#openMSAPage', 'openMSAPage');
        }
        localStorage.removeItem('createId');

        //don't start polling until 3 seconds - user will need to got through UX on MSA side for creating password, etc.
        setTimeout(() => { this.checkForAppID(this.state.uniqueId); }, 3000);

        window.open(this.msaUrl());
    }

    private msaLink() {
        const msaAppId = this.props.bot.MsaAppId;
        const classNames = ['m-button-primary-outline-md', 'button-focus'];
        if (!msaAppId) {
            classNames.push('get-agent-appId');
        }

        return (
            <button className={classNames.join(' ')}
                onClick={ () => this.openMSAPage() } >
                {msaAppId ? 'Manage' : 'Create'} {resourceStrings.appId} and password
            </button>
        );
    }

    private msaUrl() {
        const bot = this.props.bot;
        const msaAppId = bot.MsaAppId;

        if (msaAppId) {
            return clientAppSettings.msaPortalEndpoint + 'ApplicationMenuBlade/Overview/appId/' + msaAppId + '/isMSAApp/';
        } else {
            return clientAppSettings.msaPortalEndpoint + 'ApplicationsListBlade';
        }
    }

    public render(): JSX.Element {
        let appIdElement: JSX.Element[];
        let x = {} as Rest.BotService;
        const errorClass = " input-in-error";
        const msaAppId = this.props.bot.MsaAppId;
        if (this.props.inCreateMode) {
            //editable appId textbox
            var lowercaseAppId = (msaAppId || '').toLowerCase();
            var appIdError = this.props.errors[reflectName(() => (x.MsaAppId = null,  x))];
            appIdElement = [
                <input disabled={false} key="input_3"
                    type="text" maxLength={64} id="input-MsaAppId"
                    className={appIdError ? errorClass : ''}
                    placeholder={`${resourceStrings.appId} from the Microsoft App registration portal`}
                    value={lowercaseAppId}
                    onChange={ev => this.props.handleChange('MsaAppId', ev) }/>
            ];

            if (appIdError) {
                appIdElement.push(<div key="error_3" className="error-info">{appIdError}</div>);
            }

        } else {
            //show the appid but do not allow editing
            appIdElement = [
                <input key="hidden_3" type="hidden" id="input-MsaAppId" value={msaAppId} />,
                <div key="readonly_3" className="readonly-value">{msaAppId}</div>
            ];
        }

        let msaDocsLink = !this.props.bot.MsaAppId ? (
            <p><a href="https://aka.ms/azure/bots/createappid" target="_blank">{resourceStrings.msaLearnMore}</a></p>
        ) : null;

        let readonlyClass = !this.props.inCreateMode ? "readonly-value" : "";
        let showMsiResourceId = this.props.isAppTypeFlighted && this.props.bot.MsaAppType == Rest.BotAppType.UserAssignedMSI;
        let msiResourceIdSection =  showMsiResourceId ? (
            <div className="detail-row">
                <BlockRowInputLabel text="MSI Resource ID" for="input-MsaAppMSIResourceId" required={true}/>
                <input 
                    disabled={!this.props.inCreateMode}
                    value={this.props.bot.MsaAppMSIResourceId}
                    type="text"
                    id="input-MsaAppMSIResourceId"
                    className={readonlyClass}
                    onChange={ev => this.props.handleChange('MsaAppMSIResourceId', ev)}/>
            </div>
        ) : null;
        let showTenantId = this.props.isAppTypeFlighted && (this.props.bot.MsaAppType == Rest.BotAppType.SingleTenant || this.props.bot.MsaAppType == Rest.BotAppType.UserAssignedMSI);
        let tenantIdSection =  showTenantId ? (
            <div className="detail-row">
                <BlockRowInputLabel text="App Tenant ID" for="input-MsaAppTenantId" required={true}/>
                <input 
                    disabled={!this.props.inCreateMode}
                    value={this.props.bot.MsaAppTenantId} 
                    type="text"
                    id="input-MsaAppTenantId"
                    className={readonlyClass}
                    onChange={ev => this.props.handleChange('MsaAppTenantId', ev)}/>
            </div>
        ) : null;

        return (
            <div>
                {this.props.isAppTypeFlighted ?
                    <div className="detail-row">
                        <BlockRowInputLabel text='App type:' for="input-MsaAppType" />
                        <div>
                            <select
                                disabled={!this.props.inCreateMode}
                                id="input-MsaAppType"
                                onChange={ev => this.props.handleChange("MsaAppType", ev) }
                                value={this.props.bot.MsaAppType || Rest.BotAppType.MultiTenant}
                            >
                                <option value={Rest.BotAppType.MultiTenant}>Multi Tenant</option>
                                <option value={Rest.BotAppType.UserAssignedMSI}>User-Assigned Managed Identity</option>
                                <option value={Rest.BotAppType.SingleTenant}>Single Tenant</option>
                            </select>
                        </div>
                    </div>
                : null}
                <div id={this.state.uniqueId} className="bot-msa-editor detail-row">
                    <div key="detail_3" className="detail-row">
                        <label>{resourceStrings.msaLabelRegister}</label>
                        { this.msaLink() }
                        { msaDocsLink }
                    </div>
                    <div key="detail_4" className="detail-row">
                        <BlockRowInputLabel
                            text={resourceStrings.msaLabelPasteAppId}
                            required={true}
                            for="input-MsaAppId" />
                        { appIdElement }
                    </div>
                </div>
                { tenantIdSection }
                { msiResourceIdSection }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Client/Views/BotMsaEditor.tsx